import { UI } from '@genial/components';
import { Config } from '@genial/config';
import { Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import * as NB from 'native-base';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

export const EmptyProducts = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handleNavigateToCockpit = () => {
    const isAngular = window.self !== window.top;

    if (isAngular) {
      return window.open(`${Config.OriginUrlApp}/app/boleta-facil`, '_top');
    }

    navigate('Cockpit');
  };

  return (
    <NB.VStack
      py={Spacing['stack.xxxl']}
      justifyContent="center"
      alignItems="center"
      space={Spacing['stack.xxxs']}>
      <UI.Illustration name="NotEmptyIllustration" testId="empty-list-illustration" />
      <NB.VStack alignItems="center">
        <UI.Text variant="semibold">Você não possui clientes com produtos</UI.Text>
        <UI.Text variant="regular">
          Envie um nova ordem de investimentos para seus clientes.
        </UI.Text>
        <NB.HStack space={Spacing['inset.quarck']}>
          <UI.Text>Basta clicar no botão</UI.Text>
          <UI.Button
            p={0}
            variant="textLink"
            onPress={handleNavigateToCockpit}
            _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}>
            COCKPIT DE ORDENS
          </UI.Button>
        </NB.HStack>
      </NB.VStack>
    </NB.VStack>
  );
};
